import { render, staticRenderFns } from "./EMAvanzamentoAdapter.vue?vue&type=template&id=04bdf265&scoped=true&"
import script from "./EMAvanzamentoAdapter.vue?vue&type=script&lang=js&"
export * from "./EMAvanzamentoAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bdf265",
  null
  
)

export default component.exports